export function formatNumberWithCommas(number: number): string {
    return new Intl.NumberFormat('ko-KR').format(number);
}
